export const GridIdentifiers = {
	"Shipment Board": 1,
	"Address Book": 2,
	"Address Book Modal": 3,
	"Address Book Address": 4,
	Admin: 5,
	"Auto Dispatch": 6,
	"AR Dashboard Carriers": 7,
	"AR Dashboard Sales Performance": 8,
	Commodities: 9,
	Loads: 10,
	Notifications: 11,
	"Shipment Notification Modal": 12,
	Payment: 13,
	"Selected Invoices Payment": 14,
	"Quote Board": 15,
	Reports: 16,
	"Shipment Details Report": 17,
	"Routing Guide": 18,
	"Routing Guide Modal Carriers": 19,
	"Routing Guide Modal Lanes": 20,
	"Shipment Exception Modal": 21,
	Templates: 22,
	"Templates Modal": 23,
	"Vendor Management": 24,
} as const;

export type GridIdentifierName = keyof typeof GridIdentifiers;
export type GridIdentifierValue = (typeof GridIdentifiers)[GridIdentifierName];
/** Numeric grid identifier as a string — matches the API's keyed-by-id response shape. */
export type GridIdentifierKey = `${GridIdentifierValue}`;

export const gridColumnVisibilityEnums = {
	1: "Internal",
	2: "External",
	3: "All",
};
